import { useStoreActions, useStoreState } from '@discover-data/stores/restaurant/hooks';
import usePage from '@discover-data/stores/hooks/page/usePage';
import useHasLastTableQueryState from './useQueryState';

export default function useHasLastTable(): [boolean, (newHasLastTable: boolean) => Promise<void>] {
  const storeMode = useStoreState((state) => state.mode);
  const storeValue = useStoreState((state) => state.hasLastTable.value);
  const setStoreValue = useStoreActions((actions) => actions.hasLastTable.set);
  const { resetPage } = usePage();

  const [, setRouterValue] = useHasLastTableQueryState();

  async function set(newHasLastTable: boolean) {
    resetPage();

    setStoreValue(newHasLastTable);

    await setRouterValue(newHasLastTable);
  }

  return [storeValue, set];
}
